(function () {
  const COLOR_HEX = {
    zwart: '#282828',
    naturel: '#b0804a',
    goud: '#D4AF37',
    antraciet: '#383e42',
    bruin: '#964B00',
    groen: '#4b5320',
    grijs: '#808080',
    roze: '#ffc0d8',
    blauw: '#216477',
    cognac: '#834333',
    donkerblauw: '#00008B',
    donkerbruin: '#654321',
    donkergrijs: '#A9A9A9',
    donkergroen: '#023020',
    lichtbruin: '#C4A484',
    lichtgrijs: '#D3D3D3',
    zand: '#C4AF92',
    beige: '#EFE7DB',
    wit: '#ffffff',
    walnoot: '#533012',
    eiken: '#D2B48C',
    taupe: '#483C32',
    crème: '#FFFDD0',
    creme: '#FFFDD0',
    stone: '#B8A99A',
    terra: '#C4725C',
    white: '#ffffff',
    grijsgroen: '#6B7B6E',
  };

  function parseBankVariantTitle(title) {
    const parts = String(title || '')
      .split(' - ')
      .map((p) => p.trim())
      .filter(Boolean);
    const remaining = [...parts];
    let hoek = null;
    let opstelling = null;
    let zits = null;

    if (remaining.length && /^(links|rechts)$/i.test(remaining[remaining.length - 1])) {
      const raw = remaining.pop();
      hoek = raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
    }

    if (remaining.length && /opstelling/i.test(remaining[remaining.length - 1])) {
      opstelling = remaining.pop();
    }

    if (remaining.length && /^\d+-zits$/i.test(remaining[0])) {
      zits = remaining.shift();
    }

    const kleur = remaining.join(' - ') || parts[0] || title;

    return { kleur, hoek, zits, opstelling, title };
  }

  function buildZitsKey(zits, opstelling) {
    if (!zits) return null;
    if (!opstelling) return zits;
    return `${zits} - ${opstelling}`;
  }

  function normalizePath(url) {
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
    } catch {
      return String(url || '').split('?')[0].replace(/\/$/, '');
    }
  }

  function resolveColorHex(variant) {
    if (variant.colorHex) return variant.colorHex;
    const key = String(variant.kleur || '')
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    const normalizedMap = Object.fromEntries(
      Object.entries(COLOR_HEX).map(([name, hex]) => [
        name
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, ''),
        hex,
      ])
    );
    if (normalizedMap[key]) return normalizedMap[key];
    const token = key.split(/\s+/).find((t) => normalizedMap[t]);
    return token ? normalizedMap[token] : '#cccccc';
  }

  function enrichVariant(raw) {
    const parsed = parseBankVariantTitle(raw.title);
    const zits = buildZitsKey(parsed.zits, parsed.opstelling);
    return {
      ...raw,
      ...parsed,
      zits,
      path: normalizePath(raw.url),
      colorHex: raw.colorHex || resolveColorHex(parsed),
      stockMessage: raw.stockMessage ? String(raw.stockMessage).trim() : '',
    };
  }

  function isDeliveryStockMessage(message) {
    const normalized = String(message || '')
      .toLowerCase()
      .trim();
    if (!normalized) return false;
    if (normalized.includes('levertijd')) return true;
    if (/\d+\s*(weken?|dagen|werkdagen)/i.test(normalized)) return true;
    if (normalized.includes('binnen') && (normalized.includes('week') || normalized.includes('dag'))) {
      return true;
    }
    return false;
  }

  function getStockMessage(variant) {
    if (!variant) return '';
    const message = String(variant.stockMessage || '').trim();
    if (!message || isDeliveryStockMessage(message)) return '';
    if (/^op\s+voorraad$/i.test(message)) return 'Op voorraad';

    return '';
  }

  function uniqueValues(variants, key) {
    const seen = new Set();
    const values = [];
    variants.forEach((v) => {
      const val = v[key];
      if (!val || seen.has(val)) return;
      seen.add(val);
      values.push(val);
    });
    if (key === 'zits') {
      return values.sort((a, b) => {
        const numA = parseInt(String(a), 10) || 0;
        const numB = parseInt(String(b), 10) || 0;
        if (numA !== numB) return numA - numB;
        return String(a).localeCompare(String(b), 'nl');
      });
    }
    return values.sort((a, b) => a.localeCompare(b, 'nl'));
  }

  function filterVariants(variants, selection) {
    return variants.filter((v) => {
      if (selection.kleur && v.kleur !== selection.kleur) return false;
      if (selection.hoek && v.hoek !== selection.hoek) return false;
      if (selection.zits && v.zits !== selection.zits) return false;
      return true;
    });
  }

  function findMatch(variants, selection, visibleDims) {
    const filtered = filterVariants(variants, selection);
    if (!filtered.length) return null;

    const allSelected = visibleDims.every((dim) => Boolean(selection[dim]));
    if (!allSelected) {
      if (filtered.length === 1) return filtered[0];
      return null;
    }

    return filtered[0];
  }

  function closeDropdownList(list) {
    if (!list) return;
    if (window.jQuery) {
      window.jQuery(list).slideUp(200);
    } else {
      list.style.display = 'none';
    }
  }

  function closeOtherDropdowns(root, exceptList) {
    root.querySelectorAll('.js-dropdown-list').forEach((list) => {
      if (list !== exceptList) closeDropdownList(list);
    });
  }

  class BankVariantSelectors {
    constructor(root) {
      this.root = root;
      this.linksIcon = root.dataset.linksIcon || '';
      this.rechtsIcon = root.dataset.rechtsIcon || '';
      const jsonEl = root.querySelector('[data-bank-variants-json]');
      const rawVariants = jsonEl ? JSON.parse(jsonEl.textContent || '[]') : [];
      this.variants = rawVariants.map(enrichVariant);
      this.currentPath = normalizePath(window.location.pathname);
      this.selection = {};

      this.dropdowns = {
        kleur: root.querySelector('[data-dimension="kleur"]'),
        hoek: root.querySelector('[data-dimension="hoek"]'),
        zits: root.querySelector('[data-dimension="zits"]'),
      };

      this.init();
    }

    init() {
      const current =
        this.variants.find((v) => v.isCurrent) ||
        this.variants.find((v) => v.path === this.currentPath) ||
        this.variants[0];

      if (!current) return;

      this.selection = {
        kleur: current.kleur,
        hoek: current.hoek,
        zits: current.zits,
      };

      this.updateVisibility();
      this.renderAll();
      this.bindEvents();
    }

    getVisibleDimensions() {
      const dims = [];
      if (uniqueValues(this.variants, 'kleur').length > 1) dims.push('kleur');
      if (uniqueValues(this.variants, 'hoek').length > 1) dims.push('hoek');
      if (uniqueValues(this.variants, 'zits').length > 1) dims.push('zits');
      return dims;
    }

    resolveCurrentVariant() {
      const visible = this.getVisibleDimensions();
      return (
        findMatch(this.variants, this.selection, visible) ||
        this.variants.find((v) => v.isCurrent) ||
        this.variants.find((v) => v.path === this.currentPath) ||
        null
      );
    }

    findVariantForOption(dimension, value) {
      return this.variants.find((v) => {
        if (v[dimension] !== value) return false;
        if (dimension !== 'kleur' && this.selection.kleur && v.kleur !== this.selection.kleur) {
          return false;
        }
        if (dimension !== 'hoek' && this.selection.hoek && v.hoek !== this.selection.hoek) {
          return false;
        }
        if (dimension !== 'zits' && this.selection.zits && v.zits !== this.selection.zits) {
          return false;
        }
        return true;
      });
    }

    updateVisibility() {
      const visible = this.getVisibleDimensions();
      Object.entries(this.dropdowns).forEach(([dim, el]) => {
        if (!el) return;
        el.hidden = !visible.includes(dim);
      });

      if (this.variants.length <= 1 || visible.length === 0) {
        this.root.hidden = true;
      }
    }

    bindEvents() {
      this.root.addEventListener('click', (e) => {
        const option = e.target.closest('[data-bank-value]');
        if (option) {
          e.preventDefault();
          const dropdown = option.closest('.bank-variant-dropdown');
          const dimension = dropdown.dataset.dimension;
          const value = option.dataset.bankValue;
          closeDropdownList(option.closest('.js-dropdown-list'));
          this.selectOption(dimension, value);
          return;
        }

        const trigger = e.target.closest('.js-link');
        if (trigger && this.root.contains(trigger)) {
          const list = trigger.nextElementSibling;
          if (list && list.classList.contains('js-dropdown-list')) {
            closeOtherDropdowns(this.root, list);
          }
        }
      });
    }

    selectOption(dimension, value) {
      this.selection[dimension] = value;

      const visible = this.getVisibleDimensions();
      const filtered = filterVariants(this.variants, this.selection);

      visible.forEach((dim) => {
        if (dim === dimension) return;
        const options = uniqueValues(filtered, dim);
        if (options.length && !options.includes(this.selection[dim])) {
          this.selection[dim] = options[0];
        }
      });

      this.renderAll();

      const match = findMatch(this.variants, this.selection, visible);
      if (match && match.path !== this.currentPath) {
        window.location.href = match.url;
      }
    }

    renderAll() {
      const visible = this.getVisibleDimensions();
      visible.forEach((dim) => this.renderDropdown(dim, visible));
    }

    renderDropdown(dimension, visibleDims) {
      const dropdown = this.dropdowns[dimension];
      if (!dropdown) return;

      const filtered = filterVariants(this.variants, this.selection);
      const options = uniqueValues(
        filterVariants(this.variants, {
          ...this.selection,
          [dimension]: null,
        }),
        dimension
      );
      const selected = this.selection[dimension];
      const currentVariant = this.resolveCurrentVariant();

      this.renderTrigger(dropdown, dimension, selected, currentVariant);
      const listOptions = options.filter((value) => value !== selected);
      this.renderList(dropdown, dimension, listOptions);
    }

    renderTrigger(dropdown, dimension, value, match) {
      const label = dropdown.querySelector('[data-trigger-label]');
      const stock = dropdown.querySelector('[data-trigger-stock]');
      const swatch = dropdown.querySelector('[data-trigger-swatch]');
      const icon = dropdown.querySelector('[data-trigger-icon]');

      if (label) label.textContent = value || '';

      if (stock) {
        const stockMessage = getStockMessage(match);
        if (stockMessage) {
          stock.textContent = stockMessage;
          stock.removeAttribute('hidden');
        } else {
          stock.setAttribute('hidden', '');
        }
      }

      if (dimension === 'kleur' && swatch) {
        const hex = match ? resolveColorHex(match) : resolveColorHex({ kleur: value });
        swatch.style.backgroundColor = hex;
        swatch.removeAttribute('hidden');
      } else if (swatch) {
        swatch.setAttribute('hidden', '');
      }

      if (dimension === 'hoek' && icon) {
        const hoekLower = String(value || '').toLowerCase();
        if (hoekLower === 'links') {
          icon.src = this.linksIcon;
          icon.alt = 'Links';
          icon.removeAttribute('hidden');
        } else if (hoekLower === 'rechts') {
          icon.src = this.rechtsIcon;
          icon.alt = 'Rechts';
          icon.removeAttribute('hidden');
        } else {
          icon.setAttribute('hidden', '');
        }
      } else if (icon) {
        icon.setAttribute('hidden', '');
      }
    }

    createOptionMain(dimension, value) {
      const main = document.createElement('span');
      main.className = 'bank-variant-option-main';

      if (dimension === 'kleur') {
        const dot = document.createElement('span');
        dot.className = 'bank-variant-swatch';
        dot.style.backgroundColor = resolveColorHex({ kleur: value });
        main.appendChild(dot);
      }

      if (dimension === 'hoek') {
        const img = document.createElement('img');
        img.className = 'bank-variant-icon';
        img.width = 24;
        img.height = 24;
        img.alt = value;
        const hoekLower = value.toLowerCase();
        img.src = hoekLower === 'rechts' ? this.rechtsIcon : this.linksIcon;
        main.appendChild(img);
      }

      const text = document.createElement('span');
      text.className = 'js-link-title';
      text.textContent = value;
      main.appendChild(text);

      return main;
    }

    renderList(dropdown, dimension, options) {
      const list = dropdown.querySelector('.js-dropdown-list');
      if (!list) return;

      const wasOpen = list.style.display !== 'none' && list.offsetParent !== null;
      list.innerHTML = '';

      options.forEach((value) => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = 'javascript:void(0);';
        link.dataset.bankValue = value;

        link.appendChild(this.createOptionMain(dimension, value));

        const variantForOption = this.findVariantForOption(dimension, value);

        const stockMessage = getStockMessage(variantForOption);
        if (stockMessage) {
          const stock = document.createElement('span');
          stock.className = 'subproduct_instock_msg';
          stock.textContent = stockMessage;
          link.appendChild(stock);
        }

        li.appendChild(link);
        list.appendChild(li);
      });

      if (wasOpen) {
        list.style.display = 'block';
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-bank-variant-selectors]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      new BankVariantSelectors(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
